import { chartTypes } from "./chartFilterEnums";

export const reportTypeOptionKeys = {
  PIVOTTABLE:"pivottable",
  WITHCHART:"withchart",
};

// What a report counts. `base` counts the entity itself (an order, an inbound, a return), `lines`
// counts its lines, `products` sums the amounts on those lines. Missing on a report means `base`.
export const reportSubtypeKeys = {
    BASE: "base",
    LINES: "lines",
    PRODUCTS: "products",
};

export const reporthubChartOptionKeys = {
    ORDERS: "orders",
    INBOUNDS:"inbounds",
    RETURNS:"returns",
    SHIPMENTS:"shipments",
    WAREHOUSELOCATIONS:"warehouselocations",
    FINANCIAL:"invoiceinvoiceproducts",
    // Queries shipments like SHIPMENTS does — see `sourceType` in reports.js. It is a separate report
    // only so the frontend can tell the two apart and render the scan explanation for this one.
    SCANSTATUS:"scanstatus"
};

// Which environment is looking at the report. This decides which filters mean anything: a fulfilment
// warehouse asks "how is this relation doing", while a warehouse holding its own stock and a relation
// in the portal both ask "how am I doing".
//
// Not the same axis as the backend businessintelligence_source column, which only records whether a
// dashboard was built on the warehouse side or the relation side. FULFILMENT and WAREHOUSE are both
// `warehouse` there.
export const biEnvironments = {
  FULFILMENT: "fulfilment",
  WAREHOUSE: "warehouse",
  RELATION: "relation",
};

export const chartFilterKeys = {
  SHIPPER:"shipper",
  SHIPPERPROFILES:"shipperprofiles",
  STREAM:"stream",
  COUNTRIES:"countries",
  RELATIONS:"relations",
  WEBSHOPCREDENTIALS:"webshopcredentials",
  PRODUCTS:"products",
  WAREHOUSE_ZONE:"zone",
  TYPE:"type",
  WAREHOUSE_ZONE:"zone",
  WEBSHOP_TYPE:'webshop_type',
  INVOICEPRODUCTS:"invoiceproducts",
  INVOICEPRODUCTCATEGORIES:"invoiceproductcategories",
  CARRIERS:"carriers",
  SCANSTATUS:"scanstatus",
  USERS:"users",
  LOCATION_OCCUPIED:"occupied",
}
